import axios from 'axios';
// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import SettingsEntity from 'granite-admin/common/entities/settings';
import ConfigsEntity from 'granite-admin/common/entities/configs';
import ContentType from 'granite-admin/common/entities/contentType';
import FieldGroupEntity from 'granite-admin/common/entities/fieldGroup';
import ComplianceEntity from 'granite-admin/common/entities/compliance';
const url = process.env.REACT_APP_GRANITE_BASE_URL;
const base_url = process.env.REACT_APP_API_BASE_URL;
async function getMasterConfigs(type) {
  const payload = {
    params: {
      config_type: type
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/config-master/', payload);
    const list = data.results.map(e => new SettingsEntity(e));
    return list;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getAllMasterConfigs(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/config-master/', payload);
    const list = data.results.map(e => new ConfigsEntity(e));
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getConfig(id) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/config-master/${id}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getConfigByName(name, params, configType = 'OPTIONS') {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/config-master/?keys=${JSON.stringify([name])}&config_type=${configType}`, {
      params
    });
    return data?.results?.length ? new ConfigsEntity(data.results[0]) : {};
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getFieldGroup(params) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/field-group/', {
      params
    });
    return data.results.map(e => new FieldGroupEntity(e));
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function postFieldGroup(params) {
  const payload = {
    ...params
  };
  try {
    await GraniteAPIClient(url).post('/field-group/', payload);
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function postMasterValues(params) {
  const payload = {
    ...params
  };
  try {
    if (payload.pk) {
      const {
        data
      } = await GraniteAPIClient(url).put(`/config-master-value/${payload.pk}/`, payload);
      return data;
    } else {
      const {
        data
      } = await GraniteAPIClient(url).post('/config-master-value/', payload);
      return data;
    }
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function deleteMasterValues(pk) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).delete(`/config-master-value/${pk}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function postConfig(params) {
  const payload = {
    ...params
  };
  // const {organisationId}=params
  try {
    if (params.pk) {
      const {
        data
      } = await GraniteAPIClient(url).put(`/config-master/${params.pk}/`, payload);
      return data;
    } else {
      const {
        data
      } = await GraniteAPIClient(url).post('/config-master/', payload);
      return data;
    }
  } catch (error) {
    throw error;
  }
}
async function countryData() {
  try {
    const {
      data
    } = await GraniteAPIClient().get('/countries/');
    return data;
  } catch (error) {
    throw error;
  }
}
async function stateData(pk) {
  try {
    const {
      data
    } = await GraniteAPIClient().get(`/states/${pk}/`, {
      params: {
        page_size: 499
      }
    });
    return data;
  } catch (error) {
    throw error;
  }
}
async function getContentTypes(params, signal) {
  try {
    const {
      data
    } = await GraniteAPIClient().get('/content-types/', {
      params,
      signal
    });
    const list = data.results.map(e => new ContentType(e));
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getApiEndPoints(service) {
  const {
    data
  } = await GraniteAPIClient(base_url).get(`${service}/v1/docs/?method=GET`);
  return {
    [service]: data.paths
  };
}
async function getContentType(pk) {
  try {
    const {
      data
    } = await GraniteAPIClient().get(`/content-types/${pk}/`);
    const list = data.results;
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getUserAttributes(params) {
  try {
    if (!params.entity_name) return {
      results: []
    };
    const {
      data
    } = await GraniteAPIClient().get(`/content-types/user-attributes/${params.entity_name}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}

//to get the options and type of all the fields in the form. Called from dashboard layout.
async function getMasterConfigurations(fields, entityName) {
  //list of fields is an array.
  const payload = {
    params: {
      keys: JSON.stringify(fields),
      entity_name: entityName,
      page_size: fields?.length
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/config-master/', payload);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getS3Url(filename) {
  const payload = {
    params: {
      filename
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/document/upload/', payload);
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function uploadS3(url, formData) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  try {
    await axios.post(url, formData, config);
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function createFile(fileData) {
  // const payload = {params: {...params}}
  try {
    const {
      data
    } = await GraniteAPIClient().post('/document/', fileData);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getCompanyTypes() {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/company-types/list/');
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getComplianceData(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/compliance-event/', payload);
    const list = data ? data.results.map(item => new ComplianceEntity(item)) : [];
    return {
      list,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
export default {
  getMasterConfigs,
  getAllMasterConfigs,
  countryData,
  stateData,
  postConfig,
  getConfig,
  getConfigByName,
  getContentTypes,
  getContentType,
  getMasterConfigurations,
  createFile,
  uploadS3,
  getS3Url,
  getCompanyTypes,
  getUserAttributes,
  getFieldGroup,
  postFieldGroup,
  postMasterValues,
  deleteMasterValues,
  getApiEndPoints,
  getComplianceData
};